import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Metalcutting project override: related-tags view.
 *
 * Provides React components styled with mc-* CSS classes to match the
 * Metalcutting design system. Uses the same architecture as the demo
 * project but with mc-* styling.
 *
 * The core algorithm (visible-count calculation, resize handling) lives in
 * RelatedTagsRenderer and tagLayoutService — this file only controls presentation.
 *
 * NOTE: Tag items include the 'tag-badge' class (and toggle includes
 * 'tag-badge-more') solely for the measurement system in RelatedTagsRenderer.
 * Visual styling is entirely controlled by mc-* classes.
 *
 * To revert to the core default, simply delete this file.
 */
import React from 'react';
/**
 * Metalcutting-specific messages (Russian localization).
 */
export const relatedTagsMessages = {
    getMoreLabel: (hiddenCount) => `+${hiddenCount} ещё`,
    lessLabel: 'Свернуть',
};
/**
 * Metalcutting toggle badge — uses mc-* styling.
 * Includes 'tag-badge-more' class for measurement in RelatedTagsRenderer.
 */
const RelatedTagsToggleMetalcutting = ({ hiddenCount, expanded, onToggle, messages, }) => {
    if (hiddenCount === 0 && !expanded)
        return null;
    const label = expanded ? messages.lessLabel : messages.getMoreLabel(hiddenCount);
    return (_jsx("a", { href: "#", className: "mc-tag-more tag-badge-more", onClick: (e) => {
            e.preventDefault();
            onToggle();
        }, children: label }));
};
/**
 * Metalcutting container — uses mc-* styling for tag badges.
 *
 * Includes 'tag-badge' class on each item for measurement in RelatedTagsRenderer.
 * Visibility is controlled via CSS class (mc-related-tags__item--hidden)
 * instead of inline styles.
 */
const RelatedTagsContainerMetalcutting = ({ items, visibleCount, expanded, onToggle, messages, ToggleComponent, }) => {
    const hiddenCount = items.length - visibleCount;
    return (_jsxs("div", { className: "mc-related-tags", children: [items.map((item, index) => {
                const isVisible = expanded || index < visibleCount;
                return (_jsx("a", { href: item.href, className: `mc-related-tags__item tag-badge${isVisible ? '' : ' mc-related-tags__item--hidden'}`, children: item.title }, item.href + item.title));
            }), _jsx(ToggleComponent, { hiddenCount: hiddenCount, expanded: expanded, onToggle: onToggle, messages: messages })] }));
};
/**
 * Default export: returns the view contract with Metalcutting components.
 */
export default function getRelatedTagsView() {
    return {
        ContainerComponent: RelatedTagsContainerMetalcutting,
        ToggleComponent: RelatedTagsToggleMetalcutting,
        messages: relatedTagsMessages,
    };
}
